import type { RouteObject } from "react-router-dom";
import PageLayout from "../components/feature/PageLayout";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/home/page";
import RexunPage from "../pages/rexun/page";
import ReadPage from "../pages/read/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    element: <PageLayout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/rexun", element: <RexunPage /> },
      { path: "/read/:id", element: <ReadPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;